import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const PayrollentryListComponent = (props) => {

  const {t} = props;
  const [payrollentries, setPayrollentries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const loadLazyTimeout = useRef(null);
  const loadLazyData = () => {
    if (!props.employeeId) return;
    setLoading(true);
    if (loadLazyTimeout.current) {
      clearTimeout(loadLazyTimeout.current);
    }
    loadLazyTimeout.current = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      const extraFilter = `&search[employee][operator]==&search[employee][value]=${props.employeeId}`;
      apiCall('get', '/api/v2/payroll-entry' + query + extraFilter)
        .then(response => {
          const items = response?.data?.data?.items || [];
          setTotalRecords(response?.data?.data?.total_item_count || 0);
          setPayrollentries(items);
          const expanded = {};
          items.forEach(item => {
            expanded[item.id] = true;
          });
          setExpandedRows(expanded);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }, Math.random() * 1000 + 250);
  };
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const periodBodyTemplate = (rowData) => {
    const from = rowData?.payroll?.date_from;
    const until = rowData?.payroll?.date_until;
    if (!from && !until) return '';
    return (
      <>
        {from ? window.App.formatDateValue(from) : ''}
        {' - '}
        {until ? window.App.formatDateValue(until) : ''}
      </>
    );
  };

  const rowExpansionTemplate = (rowData) => {
    const payrollItems = rowData?.payroll_items || [];
    const currency = rowData?.payroll?.currency || rowData?.currency || '';

    return (
      <div className="p-3">
        <h4>Kifizetések</h4>
        <DataTable
          value={payrollItems}
          responsiveLayout="scroll"
          className="p-datatable-sm"
          emptyMessage={t('noItem')}
        >
          <Column header={t('columnItem')} body={(item) => item?.payroll_item_type?.name || ''}/>
          <Column header={t('columnAmount')} className="p-text-left" body={(item) => {
              const num = Number(item?.amount);
              if (!Number.isFinite(num)) return '';
              return window?.App?.currencyFormatter
                ? window.App.currencyFormatter(currency, num)
                : `${num} ${currency}`;
            }}
          />
        </DataTable>
      </div>
    );
  };

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'payroll-entry') {
  //                     history.push('/hr/employee/read/payroll-entry/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/payroll-entry/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderPayrollentryList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    loadLazyData();
  }, [props.employeeId, lazyParams, window.App.state.rerenderPayrollentryList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={payrollentries} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                //  filterDisplay="row"
                 responsiveLayout="scroll"
                 expandedRows={expandedRows}
                 onRowToggle={(e) => setExpandedRows(e.data)}
                 rowExpansionTemplate={rowExpansionTemplate}
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column expander style={{ width: '3rem' }} />

        <Column header={t('columnPeriod')} sortable body={periodBodyTemplate}/>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PayrollentryListComponent);
